import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import home from "../../Assets/AppComponent/Logo/Home.svg";
import Header from "../../Component/AppComponent/Header/Header";
import {
  setGraphListRetrieveActions,
  setprojectListgetdropActions,
} from "../../Redux/Slice";
import BarChart from "../../Component/AppComponent/Charts/BarChart";
import Select from "react-dropdown-select";
import { isAfter } from "date-fns";
import { DateRangePicker } from "rsuite";
import "./styles/ProjectsView.scss";
import {
  dropdownCustomStyles,
  formatInRupees,
  getDefaultDateRange,
  handleDateChange,
  predefinedDateRanges,
} from "./common/graphUtils";
import visualize_orange from "../../Assets/AppComponent/Images/visualize_orange.svg";
import { exportAmountsApi } from "../../Context/apidata";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { FaRegFilePdf } from "react-icons/fa6";

function ProjectsView() {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const [projectSelected, setProjectSelected] = useState(undefined);
  const [projectNameFeeder, setProjectNameFeeder] = useState([]);
  const dropdownRef = useRef(null);
  const [open, setOpen] = useState(false);

  const { id, projectName } = useParams();
  const dispatch = useDispatch();
  const formatDate = (date) => date.toISOString().slice(0, 10);

  const [range, setRange] = useState([
    formatDate(new Date("2025-04-09")),
    formatDate(new Date()),
  ]);

  // Get data from Redux store with proper error handling
  const graphListRetrieve = useSelector(
    (state) => state.graphListRetrieveData?.graphListRetrieve || [],
  );

  const graphError = useSelector(
    (state) => state.graphListRetrieveReducer?.Error,
  );

  // Chart states
  const [chartData, setChartData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [apiCallAttempted, setApiCallAttempted] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);

  // Get project names for the selected plant
  const projectNames = useSelector(
    (state) => state.projectListgetdropdata.projectListgetdrop,
  );

  // Load project names when component mounts or ID changes
  useEffect(() => {
    if (id.length !== 0) {
      dispatch(setprojectListgetdropActions({ id: id }));
    }
  }, [id, dispatch]);

  // Update projects dropdown when data changes
  useEffect(() => {
    setProjectNameFeeder(projectNames);
  }, [projectNames]);

  // Fetch graph data from API when relevant filters change
  useEffect(() => {
    fetchGraphData();
  }, [range, projectSelected, id]);

  // Process API data when it changes
  useEffect(() => {
    if (graphListRetrieve && graphListRetrieve.length > 0) {
      setChartData(graphListRetrieve);
    } else {
      setChartData([]);
    }
    setIsLoading(false);
  }, [graphListRetrieve, graphError, apiCallAttempted]);

  // Calculate total amount whenever chart data changes
  useEffect(() => {
    const total = chartData.reduce((sum, item) => sum + item.amount, 0);
    setTotalAmount(total);
  }, [chartData]);

  // Function to fetch graph data from API
  const fetchGraphData = () => {
    setIsLoading(true);
    setApiCallAttempted(true);
    dispatch(
      setGraphListRetrieveActions({
        filter: "project",
        plant_id: id,
        ...(projectSelected ? { project_id: projectSelected?.[0]?.value } : {}),
        ...(range[0] && range[1]
          ? { from_date: range[0], to_date: range[1] }
          : {}),
      }),
    );
  };

  // Breadcrumbs for navigation
  const breadcrumbsData = [
    {
      id: "1",
      href: "/",
      source: home,
      title: "DASHBOARD",
    },
    {
      id: "2",
      href: "/graphs",
      source: visualize_orange,
      title: `PLANT:${projectName}`,
    },
  ];

  const excelDownload = (type) => {
    const params = new URLSearchParams();
    params.append("filter", "project");
    params.append("plant_id", id);
    params.append("export_type", type);

    if (projectSelected?.[0]?.value) {
      params.append("project_id", projectSelected[0].value);
    }
    if (range[0] && range[1]) {
      params.append("from_date", range[0]);
      params.append("to_date", range[1]);
    }
    const url = `${exportAmountsApi}?${params.toString()}`;
    window.open(url, "_blank");
  };

  return (
    <div
      className={`${
        stateDisplay ? "outterContent" : "inner-Content"
      } projects-container`}
    >
      <Header breadCrumbsData={breadcrumbsData} heading="Project - Summary" />

      {/* Controls Section */}
      <div className="projects-container__controls">
        {/* Total Amount Display */}
        <div className="projects-container__total-display">
          <span className="projects-container__total-display-label">
            Total:{" "}
          </span>
          {isLoading ? (
            <span>Loading...</span>
          ) : (
            <span>{formatInRupees(totalAmount)}</span>
          )}
        </div>

        {/* Filters Section */}
        <div className="projects-container__filters">
          {/* Project Selection Dropdown */}
          <div className="projects-container__select">
            <Select
              className="Selects"
              styles={dropdownCustomStyles}
              clearable={projectSelected?.length > 0}
              onChange={(e) => setProjectSelected(e)}
              name="project"
              id="project"
              options={projectNameFeeder?.map(({ id, project }) => ({
                value: id,
                label: project,
              }))}
              value={projectSelected}
            />
          </div>

          {/* Date Range Picker */}
          <DateRangePicker
            // defaultValue={[
            //   new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
            //   new Date(),
            // ]}
            defaultValue={[new Date("2025-04-09"), new Date()]}
            placement="auto"
            // disabledDate={(date) => isAfter(date, new Date())}
            shouldDisableDate={(date) =>
              isAfter(date, new Date()) || date < new Date("2025-04-08")
            }
            editable={false}
            appearance="default"
            size="lg"
            ranges={predefinedDateRanges}
            placeholder="From - To"
            style={{ width: 300, float: "right" }}
            onChange={(e) => handleDateChange(setRange, e)}
          />
          {/* <button
            className="download"
            style={{ marginRight: "10px" }}
            onClick={(e) => {
              excelDownload();
            }}
          >
            Download Excel
          </button> */}
          <div className="split-download" ref={dropdownRef}>
            {/* Default Button */}
            <button
              className="main-btn"
              onClick={() => {
                excelDownload("excel");
              }}
              style={{
                background:
                  "linear-gradient(90deg, #F26639 -3.66%, #F79C37 -3.65%, #EF4D39 100.34%)",
              }}
            >
              Download Excel
            </button>

            {/* Arrow Button */}
            <button className="arrow-btn" onClick={() => setOpen(!open)}>
              ▼
            </button>

            {/* Dropdown */}
            {open && (
              <div className="downloadDropdown">
                <div
                  className="downloadDropdown-item"
                  onClick={() => {
                    excelDownload("excel");
                    setOpen(false);
                  }}
                >
                  <PiMicrosoftExcelLogoFill size={22} color="#F26639" />
                  Excel
                </div>
                <div
                  className="downloadDropdown-item"
                  onClick={() => {
                    excelDownload("pdf");
                    setOpen(false);
                  }}
                >
                  <FaRegFilePdf size={20} color="#F26639" />
                  PDF
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Chart Section */}
      <div>
        <div className="projects-container__chart-wrapper">
          {/* Using our reusable chart component */}
          <BarChart
            data={chartData}
            xAxisLabel="Project Number"
            yAxisLabel="Amount (₹)"
            isLoading={isLoading}
            currencySymbol="₹"
            barWidth={80}
            showXAxisLabel={false}
          />
        </div>
      </div>
    </div>
  );
}

export default ProjectsView;
